import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ProjectsService } from '../../../../../shared/API-Service/services/projects.service';
import Swal from 'sweetalert2';
import {BaseComponent } from '../../../../../../app/shared/components/base/base.component'
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../../../../../../environments/environment.prod';

@Component({
  selector: 'app-list-projects',
  templateUrl: './list-projects.component.html',
  styleUrls: ['./list-projects.component.css']
})
export class ListProjectsComponent extends BaseComponent implements OnInit {
  Projects: any;
  closeResult: string;
  ShowPhoto: boolean;
  images: any[]=[];
  imagesView: string | ArrayBuffer;
  ProjectId: any;
  Image: File;
  ProjectName: any;
  CreatMediaProjectPicForm: any = new FormData();
  ProjectImages: any;
  disabled:boolean
  constructor(public modalService: NgbModal,private _formBuilder: FormBuilder,private ProjectsService:ProjectsService,private _Router:Router) { super()}
  insertForm: FormGroup;
  @ViewChild('fileInput', {static: false})
  myFileInput: ElementRef;
  ngOnInit(): void {
    this.getProjects();
    this.initForm();
  }
  initForm() {
    this.insertForm = this._formBuilder.group({
      title: [''],
      titleAr: ['', Validators.required],

    });
  }
  open(content,item) {
    this.ProjectId=item.id;
    this.ProjectName=item.titleAr
    this.GetProjectImages(this.ProjectId)
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true,size: 'xl'  }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
GetProjectImages(projectId){
  this.ProjectsService.GetProjectImages(projectId).subscribe(res=>{
    this.ProjectImages=res.data;
    this.ProjectImages.forEach(element => {
      element.image=environment.ServerImages_URL+'/'+element.image
    });
  })
}
  get fc() {
    return this.insertForm.controls;
  }
  private getDismissReason(reason: any): string {
  
    if (reason === ModalDismissReasons.ESC) {

      this.insertForm.reset();
      this.imagesView="";

      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      this.insertForm.reset();
      this.imagesView="";

      return 'by clicking on a backdrop';
    } else {
      this.insertForm.reset();
      this.imagesView="";

      return `with: ${reason}`;
    }
  }

  modalclose(){
    this.insertForm.reset();
    this.imagesView="";
    this.modalService.dismissAll();
  }

  onFileSelected(event:any) {
    this.Image=null
    var files = event.target.files;
    this.Image = files[0];
    const reader = new FileReader();
    const video = "video";
    if(files[0].type?.includes(video)){
      this.ShowPhoto=false;
    }
    else{
     this.ShowPhoto=true;
    }
    reader.readAsDataURL(files[0]);
    reader.onload = () => {
      this.images.push(files[0]);
      
      this.imagesView = reader.result;
    }
    reader.onloadend = (_event) => {
      event.target.value = null; // Reset the value of the file input element
    };
 
  }

  deleteimage(imgindex) {
    this.images.splice(imgindex, 1);
    this.imagesView=null
    this.Image=null

  }
  deleteProjectImage(id){
    Swal.fire({
      title: 'هل تريد مسح العنصر ؟',
      text: "لن يكون لك صلاحية إعادته مره اخرى",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'الغاء',
      confirmButtonText: 'امسح العنصر !'
    }).then((result) => {
      if (result.isConfirmed) {
        this.ProjectsService.DeleteProjectImages(id).subscribe((res) => {
          Swal.fire({
            icon: "success",
            title: "تم المسح بنجاح",
            showConfirmButton: false,
            timer: 1500,
          });
       this.GetProjectImages(this.ProjectId);
       this.myFileInput.nativeElement.value = '';

        },(err) => {
          Swal.fire({
            icon: 'error',
            title: 'خطأ',
            text:err.error.message    
          })
        },() => {
        })
      }
    }) 
  
  }
OpenImage(imagesView){
    Swal.fire({
      imageUrl: imagesView,
      imageHeight: 400,
      imageAlt: 'A tall image',
      confirmButtonText:"الغاء"
    })
  }
  pageChanged(event: any){
    this.pageNumber = event.page;// -1 * pageSize;
    this.pager.skipCount = (this.pageNumber - 1) * this.pager.maxResultCount;
this.getProjects()

  }
  getProjects(){
   
    this.ProjectsService.GetProjectsPaged(this.pager).subscribe((res) => {
      this.Projects = res.data.items
      this.totalCount=res.data.totalCount;
    
    },(err)=>{
    },() =>{
    });
  }
  update(id){
    this._Router.navigate(['/content/admin/update-project',id]);
    }

    delete(id : number){
      Swal.fire({
        title: 'هل تريد مسح العنصر ؟',
        text: "لن يكون لك صلاحية إعادته مره اخرى",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'الغاء',
        confirmButtonText: 'امسح العنصر !'
      }).then((result) => {
        if (result.isConfirmed) {
          this.ProjectsService.DeleteProject(id).subscribe((res) => {
            Swal.fire({
              icon: "success",
              title: "تم المسح بنجاح",
              showConfirmButton: false,
              timer: 1500,
            });
         this.getProjects();
          },(err) => {
            Swal.fire({
              icon: 'error',
              title: 'خطأ',
              text:err.error.message    
            })
          },() => {
          })
        }
      }) 
    }

    GotoProjectCompletion(id){
      this._Router.navigate(['/content/admin/ViewProjectCompletion',id]);
    }

    Submit(){
      this.disabled=true
      if (this.insertForm.status == "VALID") {
        this.CreatMediaProjectPicForm.set("ProjectImage", this.Image);
      this.CreatMediaProjectPicForm.set('title',this.insertForm.get('title').value)
      this.CreatMediaProjectPicForm.set('TitleAr',this.insertForm.get('titleAr').value)
      this.CreatMediaProjectPicForm.set('ProjectId',this.ProjectId)
      this.ProjectsService.CreateProjectImage(this.CreatMediaProjectPicForm).subscribe(
        (response) => {
        Swal.fire({
        icon: "success",
        title: "تم الحفظ بنجاح",
        showConfirmButton: false,
        timer: 1500,
        });
        this.disabled=false

        this.GetProjectImages(this.ProjectId);
        this.insertForm.reset();
        this.imagesView=null;
        this.images=[];
        this.Image=null
        this.myFileInput.nativeElement.value = '';
        this.onFileSelected(null);

      },
        (err) => {
          this.disabled=false

          Swal.fire({
            icon: "error",
            title:err.error.message
            });
        });
      }
       else {
        this.disabled=false

        this.insertForm.markAllAsTouched();
      }
      
    }



}
